import { createBrowserHistory } from 'history';
var history;
var __get_history__ = function () {
    if (history)
        return history;
    history = createBrowserHistory({ window: window });
    return history;
};
export default function useHistory() {
    return __get_history__();
}
//# sourceMappingURL=useHistory.js.map